<template>
  <div>
    <search-input
      alias="Nota Fiscal Referenciada"
      v-model="form.chNFe.value"
      :displayedValue="form.chNFe.value"
      :form="form"
      :name="'chNFe'"
      @search="searchNfe($event)"
      :searchResult="searchNfeResults.results"
      :isLoading="searchNfeResults.isLoading"
      @selected="setNfe($event)"
    >
      <search-input-option
        v-for="(row, index) in searchNfeResults.results.data"
        :key="index"
        :index="index"
        @click="setNfe(row)"
      >
        <div class="d-flex justify-content-between">
          <div>
            <small class="text-muted">{{ row.client_id }} </small> -
            {{ row.dest_xNome }}
            <br />
            <small class="text-muted">{{ row.chNFe }} &nbsp;</small>
          </div>
          <div class="text-right">
            {{ row.vNF | decimal }}
            <template>
              <p>
                <small class="text-muted">NF: {{ row.nNF }}</small>
              </p>
            </template>
          </div>
        </div>
      </search-input-option>
    </search-input>
  </div>
</template>

<script>
  import Form from "./../mixins/Form.js";

  export default {
    props: {
      value: {}
    },

    data: function() {
      return {
        form: new Form({
          chNFe: {}
        }),

        searchNfeResults: {
          results: {},
          isLoading: false
        }
      };
    },

    created() {
      this.form.chNFe.value = this.value;
    },

    computed: {
      chNFe() {
        return this.form.chNFe.value;
      }
    },

    watch: {
      chNFe(newValue) {
        this.$emit("input", newValue);
      },

      value: function(newValue, oldValue) {
        this.form.chNFe.value = newValue;
      }
    },

    methods: {
      // search person for seachInput component\
      searchNfe(search) {
        this.searchNfeResults.isLoading = true;

        axios
          .post(process.env.BASE_URL + "api/nfe/search?page=" + search.page, {
            name: search.text
          })
          .then(response => {
            this.searchNfeResults.results = response.data;

            this.searchNfeResults.isLoading = false;
          })
          .catch(error => {
            console.log(error);
            this.error = error;
          });
      },

      setNfe(nfe) {
        this.selected = nfe;

        this.form.chNFe.value = nfe.chNFe;
      }
    }
  };
</script>

<style>
</style>
